import React from "react";
import { Box } from "@material-ui/core";
import { CustomerContractCustomerListFragment } from "@graphql";
import CustomerCard from "@customers/CustomerCard/CustomerCard";

type Props = {
  data: CustomerContractCustomerListFragment;
};

export function CustomerContractCustomerList(props: Props) {
  return (
    <div>
      {props.data.orgCustomers.map((customer) => (
        <Box mb={1}>
          <CustomerCard data={customer as any} />
        </Box>
      ))}
    </div>
  );
}
